import React from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';

import ContactInfo from '../ContactInfo';

const NavMenuPublic = ({ hideBrand, tagline, brandingText }) => {
    const brand = hideBrand ? null : tagline ? (
        <Navbar.Brand>{tagline}</Navbar.Brand>
    ) : (
            <Navbar.Brand>{brandingText ? brandingText : 'MyAccount Manager'}&trade;</Navbar.Brand>
        );

    return (
        <Navbar id="header" className="public-header" collapseOnSelect>
            <Navbar.Header>
                {brand}
                <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse className="no-transition">
                <Nav pullRight>
                    <ContactInfo />
                    <NavItem className="hidden"></NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default connect((state) => state.app, null)(NavMenuPublic);
